const mainSearchForm = {
  flights: "フライト", // translated
  tours: "ツアー", // translated
  hotel: "ホテル", // translated
  hotels: "ホテル", // translated
  services: "サービス", // translated
  search: "検索", // translated
  destination: "目的地", // translated
  includedServices: "含まれるサービス", // translated
  packageDuration: "パッケージ期間", // translated
  checkInOut: "チェックイン/チェックアウト", // translated
  guests: "ゲスト", // translated
  adults: "大人", // translated
  children: "子供", // translated
  child: "子供", // translated
  age: "年", // translated
  yearsOld: "歳", // translated
  rooms: "部屋", // translated
  close: "近い", // translated
  searchType: "検索タイプ", // translated
  accommodation: "宿泊施設", // translated
  transfers: "転送", // translated
  toursExperiences: "ツアー・体験", // translated
  nights: "夜", // translated
  days: "日々", // translated
  packageType: "パッケージ型式", // translated
  tourType: "ツアータイプ", // translated
  packages: "パッケージ", // translated
  cars: "車", // translated
  cruises: "クルーズ", // translated
  infantsInSeat: "座席に座る幼児", // translated
  infantsOnLap: "膝の上の幼児", // translated
  airport: "空港", // translated
  passengers: "乗客", // translated
  departureReturn: "出発日と帰国日", // translated
  origin: "起源", // translated
  roundTrip: "往復", // translated
  isRoundTrip: "往復です", // translated
  dream_packages: "ドリームパッケージ", // translated
  partying: "パーティー", // translated
  thingsToDo: "やる事", // translated
};



export default mainSearchForm;
